export default __webpack_public_path__ + "static/media/spheres.cf50c7f9.wav";